export default __webpack_public_path__ + "static/media/Staff of Souls.5d5cd2ad.jpg";